import { view } from '@yola/ws-sdk';

const getComponent = () => {
  const liveDocument = view.accessors.getLiveDocument();
  return liveDocument.defaultView.customElements.get('ws-contact-form-container');
};

export default getComponent;
